import { render, staticRenderFns } from "./DashboardApplicationsStatus.vue?vue&type=template&id=7885cd38&"
import script from "./DashboardApplicationsStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardApplicationsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports